import { html, unsafeCSS } from 'lit';
import { property } from 'lit/decorators.js';
import { BaseElement, customElement } from '../../base-element';
import '../../text';
import '../../image';
import { logos } from '../../../assets/logos';
import styles from './loading-info.scss?inline';

@customElement('ps-loading-info')
export class LoadingInfoWC extends BaseElement {
  static styles = unsafeCSS(styles);

  @property({ type: Array }) steps: string[];

  @property({ type: Boolean, reflect: true }) paused = false;

  private currentStepIndex = 0;

  private animationInterval: number | null = null;

  connectedCallback() {
    super.connectedCallback();
    if (!this.paused) this.startAnimation();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.stopAnimation();
  }

  updated(changedProperties: Map<string | number | symbol, unknown>) {
    if (changedProperties.has('paused')) {
      if (!this.paused) {
        this.startAnimation();
      } else {
        this.stopAnimation();
      }
    }
  }

  private startAnimation() {
    if (this.animationInterval !== null) {
      return;
    }

    // Set initial step
    this.currentStepIndex = 0;

    // Animate through all steps with timing
    // Each step stays visible for 1.5s before transitioning to the next
    this.animationInterval = window.setInterval(() => {
      if (this.currentStepIndex < this.steps.length - 1) {
        this.currentStepIndex += 1;
        this.requestUpdate();
      } else {
        this.stopAnimation();
      }
    }, 1500);
  }

  private stopAnimation() {
    if (this.animationInterval !== null) {
      window.clearInterval(this.animationInterval);
      this.animationInterval = null;
    }
  }

  render() {
    return html`<div class="c-loading-info">
      <div class="c-loading-info__icon-container">
        <div class="c-loading-info__icon-wrapper">
          <div class="c-loading-info__icon">
            <ps-image src=${logos.proStudio} width="64" height="64"></ps-image>
          </div>
        </div>
      </div>

      <div class="c-loading-info__message-container">
        <div
          class="c-loading-info__message-container-inner"
          style="transform: translateY(calc(-${this
            .currentStepIndex} * 24px + 24px));"
        >
          ${this.steps.map(
            (item) => html`<ps-text-body size="small">${item}</ps-text-body>`
          )}
        </div>
      </div>
    </div>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'ps-loading-info': LoadingInfoWC;
  }
}
